import { render, staticRenderFns } from "./TheNotifications.vue?vue&type=template&id=892b4cca&scoped=true"
import script from "./TheNotifications.vue?vue&type=script&lang=js"
export * from "./TheNotifications.vue?vue&type=script&lang=js"
import style0 from "./TheNotifications.vue?vue&type=style&index=0&id=892b4cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b4cca",
  null
  
)

export default component.exports